module.exports = __webpack_public_path__ + "static/media/img1-400-400.927aca95.png";